import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { PolizzeFormComponent } from './dialogs/form/form.component';
import { PolizzeRoutingModule } from './polizze-routing.module';
import { PolizzeComponent } from './polizze.component';
import { SommeAssicurateModule } from './somme-assicurate/somme-assicurate.module';
import { PolizzaViewModule } from './view/polizza-view.module';
import { RicercaPolizzeModule } from './search/ricerca-polizze.module';

@NgModule({
  declarations: [PolizzeComponent, PolizzeFormComponent],
  imports: [
    CommonModule,
    PolizzeRoutingModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
    SommeAssicurateModule,
    PolizzaViewModule,
    RicercaPolizzeModule,
  ]
})
export class PolizzeModule { }
